module.exports = __webpack_public_path__ + "img/c-en-28.f3f42844.png";